import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { trackingEvents } from 'modules/core/lib/Tracking'

import NewQuestionModal from 'modules/reports/components/NewQuestionModal'
import { useReportTracking } from 'modules/reports/hooks/useReportTracking'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const NewQuestionModalPage = () => {
  const { track } = useReportTracking()
  const navigate = useNavigate()
  const { dashboard } = useOutletContext<RouteContextParams>()
  const { navigation } = useNavigation()

  const onSuccess = (reportId: string) => {
    track(trackingEvents.reports.submitReportFromQuestion)
    track(trackingEvents.reports.newReportSavedFromAiQuestion)
    navigate(navigation.reports.id.sqlEditor.fullPath({ id: reportId }))
  }

  return dashboard ? (
    <NewQuestionModal
      dashboard={dashboard}
      onClose={() =>
        navigate(
          navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: dashboard.id })
        )
      }
      onSuccess={onSuccess}
    />
  ) : null
}

export default NewQuestionModalPage
